export const SELECT_ITEM_USE_SCANNED_NAME = {
  label: 'Use scanned name',
  value: 'use-scanned-name',
} as const
